import styled from 'styled-components';

export const ErrorBox = styled.div`
  color: #6351ed;
  font-size: 14px;
  line-height: 1.42857143;
  text-align: left;
`;
